import { BackArrow } from "themes/Icon";
import ButtonComp from "themes/elements/Button";
import style from "../../../CreateNotification/create_noti.module.scss";

function Header(props) {
  const {
    handleClose,
    isEdit,
    myNewsArticle,
    handleTabChange,
    checkDraftValidation,
    checkValidation,
    loadingPublish,
    loadingDraft,
  } = props;

  return (
    <>
      <div
        className={`flex align-center justify-between w-full ${style["header-container"]}`}
      >
        <div className="flex align-center gap-2">
          <span onClick={handleClose} className="pointer">
            <BackArrow />
          </span>
          <h2 className="page-title">
            {isEdit
              ? "Edit Initiatives & Projects"
              : "Add new Initiatives & Projects"}
          </h2>
        </div>
        <div className="flex align-center wrap gap-4">
          <ButtonComp onClick={handleClose} variant="secondary">
            Cancel
          </ButtonComp>
          {!myNewsArticle && (
            <ButtonComp
              loading={loadingDraft}
              onClick={() => {
                handleTabChange("5");
                checkDraftValidation();
              }}
              variant="secondary"
            >
              Save as draft
            </ButtonComp>
          )}
          <ButtonComp
            // loading={loadingPublish}
            onClick={() => {
              checkValidation();
            }}
          >
            {myNewsArticle ? "Publish" : "Submit for approval"}
          </ButtonComp>
        </div>
      </div>
    </>
  );
}

export default Header;
